<template>
  <div>
    <Toolbar :handle-reset="resetForm" :handle-submit="onCreateTopic" />
    <TopicForm
      :errors="violations"
      :values="item"
      ref="createForm"
      refForm="createForm"
      :parent="this.parent"
      :loading="isLoading"
    />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import TopicForm from "../../components/topic/Form.vue";
import Loading from "../../components/Loading";
import Toolbar from "../../components/Toolbar";
import CreateMixin from "../../mixins/CreateMixin";
import {mapGetters} from "vuex";

const servicePrefix = "Topic";

const { mapFields } = createHelpers({
  getterType: "topic/getField",
  mutationType: "topic/updateField",
});

export default {
  name: "TopicCreate",
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    TopicForm,
  },
  data() {
    return {
      item: {},
      parent: {},
    };
  },
  computed: {
    ...mapFields(["error", "isLoading", "created", "deleted", "violations"]),
    ...mapGetters("topic", ["find"]),
  },
  methods: {
    ...mapActions("topic", {
      create: "create",
    }),
    onCreateTopic() {
       if (this.$route.params.parent) {
          this.$refs.createForm.item.parent =  this.$route.params.parent
       }
      this.onSendForm();
    }
  },
  created() {
    this.parent = this.$route.params.parent
      ? this.find(this.$route.params.parent)
      : {};
  },
};
</script>
